/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StripeSubscriptionProductsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StripeSubscriptionProductsQuery = { __typename?: 'Query', stripeSubscriptionProducts?: Array<{ __typename?: 'StripeProduct', id: string, name?: string | null, description?: string | null, default_price?: { __typename?: 'StripePrice', id: string, unit_amount: number } | null, metadata?: { __typename?: 'Metadata', background_colour?: string | null, information_section_item_1?: string | null, information_section_item_2?: string | null, information_section_list?: string | null, order_number?: string | null } | null } | null> | null };


export const StripeSubscriptionProductsDocument = gql`
    query stripeSubscriptionProducts {
  stripeSubscriptionProducts {
    id
    name
    description
    default_price {
      id
      unit_amount
    }
    metadata {
      background_colour
      information_section_item_1
      information_section_item_2
      information_section_list
      order_number
    }
  }
}
    `;

/**
 * __useStripeSubscriptionProductsQuery__
 *
 * To run a query within a React component, call `useStripeSubscriptionProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeSubscriptionProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeSubscriptionProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripeSubscriptionProductsQuery(baseOptions?: Apollo.QueryHookOptions<StripeSubscriptionProductsQuery, StripeSubscriptionProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeSubscriptionProductsQuery, StripeSubscriptionProductsQueryVariables>(StripeSubscriptionProductsDocument, options);
      }
export function useStripeSubscriptionProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeSubscriptionProductsQuery, StripeSubscriptionProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeSubscriptionProductsQuery, StripeSubscriptionProductsQueryVariables>(StripeSubscriptionProductsDocument, options);
        }
export function useStripeSubscriptionProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StripeSubscriptionProductsQuery, StripeSubscriptionProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeSubscriptionProductsQuery, StripeSubscriptionProductsQueryVariables>(StripeSubscriptionProductsDocument, options);
        }
export type StripeSubscriptionProductsQueryHookResult = ReturnType<typeof useStripeSubscriptionProductsQuery>;
export type StripeSubscriptionProductsLazyQueryHookResult = ReturnType<typeof useStripeSubscriptionProductsLazyQuery>;
export type StripeSubscriptionProductsSuspenseQueryHookResult = ReturnType<typeof useStripeSubscriptionProductsSuspenseQuery>;
export type StripeSubscriptionProductsQueryResult = Apollo.QueryResult<StripeSubscriptionProductsQuery, StripeSubscriptionProductsQueryVariables>;